exports.default = undefined;
const { extend } = require('vee-validate');

// Install rules
_default = extend('zip', {
    validate(value, { country }) {
        let regex;
        switch (country) {
        case 'be':
            regex = /^(?:(?:[1-9])(?:\d{3}))$/;
            break;
        case 'br':
            regex = /^[0-9]{5}\s[0-9]{3}$/;
            break;
        case 'es':
            regex = /^[0-9]{5}$/;
            break;
        case 'fr':
            regex = /^[0-9]{5}$/;
            break;
        case 'it':
            regex = /^[0-9]{5}$/;
            break;
        case 'nl':
            regex = /^[1-9][0-9]{3} ?(?!sa|sd|ss)[A-Za-z]{2}$/;
            break;
        case 'pt':
            regex = /^\d{4}-\d{3}$/;
            break;
        default:
            regex = /^[0-9]+$/;
            break;
        }
        return regex.test(value);
    },
    params: ['country'],
});

exports.default = _default;
